
// READ MORE LESS 

document.addEventListener("DOMContentLoaded", function () {
    function setupReadMore() {
        const charLimit = 262;

        document.querySelectorAll(".text-column__text").forEach(textBlock => {
            let content = textBlock.innerHTML.trim();
            
            if (content.length > charLimit) {
                let visibleText = content.substring(0, charLimit);
                let hiddenText = content.substring(charLimit);

                textBlock.innerHTML = `
                    ${visibleText}<span class="more-ellipses">...</span>
                    <span class="more-text">${hiddenText}</span>
                `;

                let button = document.createElement("button");
                button.classList.add("read-more-btn");
                button.textContent = "Read More";
                textBlock.after(button);

                button.addEventListener("click", function () {
                    let moreText = textBlock.querySelector(".more-text");
                    let ellipses = textBlock.querySelector(".more-ellipses");

                    if (moreText.style.display === "none" || moreText.style.display === "") {
                        moreText.style.display = "inline";
                        ellipses.style.display = "none";
                        this.textContent = "Read Less";
                    } else {
                        moreText.style.display = "none";
                        ellipses.style.display = "inline";
                        this.textContent = "Read More";
                    }
                });
            }
        });
    }

    setTimeout(setupReadMore, 500);

    document.addEventListener("shopify:section:load", setupReadMore);
});



// SLIDER Swiper
document.addEventListener("DOMContentLoaded", function () {
    var swiperThumbs = new Swiper(".mySwiper", {
      spaceBetween: 10,
      slidesPerView: 4,
      freeMode: true,
      watchSlidesProgress: true,
    });

    var swiperMain = new Swiper(".mySwiper2", {
      loop: false,
       effect: "fade",
      autoHeight: true,
      spaceBetween: 10,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      thumbs: {
        swiper: swiperThumbs,
      },
    });
  });

 
// MODEL PAGE POPUP

$(document).ready(function () {
    $(".open").click(function () {
        var popupId = $(this).data("id");
        $("#" + popupId).fadeIn("slow");
        $("body").addClass("no-scroll"); // Disable scrolling
    });

    $(".close").click(function () {
        $(this).closest(".pop-outer").fadeOut("slow");
        $("body").removeClass("no-scroll"); // Enable scrolling again
    });
  });











